import React from 'react';
import { Icons } from '../../../components/atoms/SVG';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  createButtonObject,
  DISPLAY_TYPE,
} from '../../../components/organisms/BlockInteractions';
import { Namespace } from '../../../translation/namespace';
import { ExternalContentEditView } from '../views/ExternalContentEditView';
import { DefaultView, DeleteAction, OptionalEditView, Views } from '../../../types/BlockWithViews';
import { ExternalContentEditDefaultView } from '../views/ExternalContentEditDefaultView';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useContentWrapperContext } from '../../../components/blocks/ContentWrapper/ContentWrapperContext';
import { ExternalContentDefaultViewProps } from '../views/ExternalContentDefaultView';
import { useContentWrapperDndContext } from '../../../components/blocks/ContentWrapper/ContentWrapperDndProvider';

export type ExternalContentBlockProps = Views<
  DefaultView<ExternalContentDefaultViewProps> & OptionalEditView<ExternalContentEditView> & DeleteAction
>;

export function ExternalContentInteractions({ views, activeView = 'default' }: ExternalContentBlockProps) {
  const { t } = useSonTranslation('ExternalContent');

  const { uuid, elementType } = useBlockContext();
  const { refresh, refreshCount } = useRefreshBlock();
  const contentWrapperProps = useContentWrapperContext();
  const contentWrapperDndProps = useContentWrapperDndContext();

  const buttons = {
    ...(views.edit &&
      createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        `${Namespace.ExternalContent}:edit`,
        DISPLAY_TYPE.COLLAPSIBLE,
        <ExternalContentEditView {...views.edit} />,
      )),
    ...(views.delete &&
      createButtonObject(
        BlockInteractionsViews.DELETE,
        Icons.ERASER,
        'ExternalContent:delete',
        DISPLAY_TYPE.MODAL,
        null,
      )),
  };

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={elementType}
      headline={{
        text: t('headline'),
        hierarchy: 3,
        visible: true,
      }}
      views={views}
      activeView={activeView}
      buttons={buttons}
      contentWrapperProps={contentWrapperProps}
      contentWrapperDndProps={contentWrapperDndProps}
      refreshBlock={refresh}
      refreshCount={refreshCount}
    >
      <ExternalContentEditDefaultView {...views.default} />
    </BlockInteractions>
  );
}
